import type { Definition } from "mdast"

import type { MarkdownNodeRenderer } from "../types.ts"

export const renderDefinition: MarkdownNodeRenderer<Definition> = () => {
  return null
}
